import { createSelector } from 'reselect';
import { processSelectors } from '../../process';

const getInitialValues = processId => createSelector([processSelectors.getById], processById => processById[processId]);

export const makeGetInitialValues = createSelector(getInitialValues, initialValues => initialValues);
